var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJoistEdgeMainLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "230px",
    height: "68px",
    viewBox: "0 0 229 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1 24 L 24 24 L 24 57.207031 L 1 57.207031 Z M 1 24 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 31 23 L 67 23 L 67 57.207031 L 31 57.207031 Z M 31 23 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 89 23 L 115 23 L 115 57.207031 L 89 57.207031 Z M 89 23 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 139 18 L 149.839844 18 L 149.839844 31 L 139 31 Z M 139 18 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(98.039216%,98.039216%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 12.09375 57.398438 C 7.011719 57.398438 3.652344 55.152344 1.414062 52.488281 L 5.9375 47.441406 C 7.804688 49.496094 9.621094 50.71875 11.90625 50.71875 C 14.613281 50.71875 16.292969 49.082031 16.292969 45.296875 L 16.292969 24.210938 L 23.660156 24.210938 L 23.660156 45.617188 C 23.660156 53.5625 19 57.398438 12.09375 57.398438 Z M 12.09375 57.398438 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(98.039216%,98.039216%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 48.78125 57.488281 C 38.703125 57.488281 31.476562 49.964844 31.476562 40.660156 L 31.476562 40.566406 C 31.476562 31.265625 38.800781 23.648438 48.875 23.648438 C 58.949219 23.648438 66.175781 31.175781 66.175781 40.476562 L 66.175781 40.566406 C 66.175781 49.871094 58.851562 57.488281 48.78125 57.488281 Z M 58.667969 40.566406 C 58.667969 34.960938 54.5625 30.285156 48.78125 30.285156 C 43 30.285156 38.988281 34.867188 38.988281 40.476562 L 38.988281 40.566406 C 38.988281 46.175781 43.089844 50.851562 48.875 50.851562 C 54.65625 50.851562 58.683594 46.273438 58.683594 40.660156 L 58.683594 40.566406 Z M 58.667969 40.566406 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(98.039216%,98.039216%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 73.9375 24.199219 L 81.117188 24.222656 L 81.019531 56.9375 L 73.828125 56.917969 Z M 73.9375 24.199219 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(98.039216%,98.039216%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 102.960938 57.398438 C 97.859375 57.417969 92.929688 55.550781 89.109375 52.160156 L 93.351562 47.066406 C 96.292969 49.496094 99.371094 51.039062 103.101562 51.039062 C 106.039062 51.039062 107.808594 49.871094 107.808594 47.953125 L 107.808594 47.859375 C 107.808594 46.039062 106.691406 45.101562 101.234375 43.691406 C 94.660156 42.007812 90.414062 40.183594 90.414062 33.6875 L 90.414062 33.605469 C 90.414062 27.667969 95.171875 23.742188 101.839844 23.742188 C 106.597656 23.742188 110.65625 25.230469 113.96875 27.914062 L 112.886719 29.488281 L 110.238281 33.339844 C 109.863281 33.078125 109.488281 32.832031 109.121094 32.601562 C 106.609375 31.035156 104.148438 30.113281 101.746094 30.113281 C 98.996094 30.113281 97.550781 31.371094 97.550781 32.964844 L 97.550781 33.054688 C 97.550781 35.207031 98.949219 35.90625 104.59375 37.359375 C 111.214844 39.085938 114.945312 41.46875 114.945312 47.171875 L 114.945312 47.265625 C 114.945312 53.761719 110.003906 57.410156 102.960938 57.410156 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(98.039216%,98.039216%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 136.589844 56.929688 L 129.417969 56.929688 L 129.417969 30.847656 L 119.472656 30.847656 L 119.472656 24.210938 L 136.550781 24.210938 Z M 136.589844 56.929688 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(98.039216%,98.039216%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 149.085938 24.648438 L 139.390625 30.605469 L 139.390625 24.191406 L 149.085938 18.234375 L 149.085938 24.644531 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(98.039216%,98.039216%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 139.390625 12.15625 L 139.390625 18.566406 L 143.414062 20.675781 L 148.269531 17.605469 Z M 139.390625 12.15625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 168.460938 22.667969 L 160.476562 30.671875 L 160.476562 49.902344 L 217.109375 49.902344 L 225.097656 41.898438 L 225.097656 22.667969 Z M 177.628906 32.847656 L 171.871094 32.847656 L 171.871094 34.863281 L 177.5 34.863281 L 177.5 37.515625 L 171.871094 37.515625 L 171.871094 39.699219 L 177.628906 39.699219 L 177.628906 42.339844 L 168.75 42.339844 L 168.75 30.203125 L 177.628906 30.203125 Z M 185.265625 42.347656 L 180.160156 42.347656 L 180.160156 30.210938 L 185.246094 30.210938 C 189.054688 30.210938 191.800781 32.5 191.800781 36.265625 C 191.800781 40.035156 189.0625 42.347656 185.265625 42.347656 Z M 205.378906 40.199219 C 204.070312 41.640625 202.308594 42.566406 200.023438 42.566406 C 196.410156 42.566406 193.464844 40.148438 193.464844 36.289062 C 193.464844 32.429688 196.410156 30.011719 200.023438 30.011719 C 202.671875 30.011719 204.304688 31.324219 205.195312 32.832031 L 202.578125 34.210938 C 202.089844 33.410156 201.164062 32.773438 200.023438 32.773438 C 198.042969 32.773438 196.648438 34.304688 196.648438 36.28125 C 196.648438 38.261719 198.050781 39.792969 200.023438 39.792969 C 200.96875 39.792969 201.824219 39.464844 202.308594 39.0625 L 202.308594 38.046875 L 199.53125 38.046875 L 199.53125 35.449219 L 205.378906 35.449219 Z M 216.8125 32.847656 L 211.058594 32.847656 L 211.058594 34.863281 L 216.683594 34.863281 L 216.683594 37.515625 L 211.058594 37.515625 L 211.058594 39.699219 L 216.8125 39.699219 L 216.8125 42.339844 L 207.933594 42.339844 L 207.933594 30.203125 L 216.8125 30.203125 Z M 216.8125 32.847656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 185.273438 32.9375 L 183.292969 32.9375 L 183.292969 39.617188 L 185.25 39.617188 C 187.378906 39.617188 188.609375 38.070312 188.609375 36.265625 C 188.609375 34.460938 187.484375 32.9375 185.265625 32.9375 Z M 185.273438 32.9375 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoistEdgeMainLogo);
export default __webpack_public_path__ + "static/media/joist_edge_main_logo.e55919c024472eb589550101d0808ca4.svg";
export { ForwardRef as ReactComponent };